import styled from '@emotion/styled'

import tokens from '../../design/tokens'

import {
  GRID_VARIANT_COLLAPSED,
  GRID_VARIANT_DEFAULT,
  GRID_VARIANT_SMALL,
  GRID_VARIANT_VERTICAL_BIG,
  GRID_VARIANT_VERTICAL_DEFAULT
} from './Grid.constants'

const handleVariant = ({ variant }) => {
  switch (variant) {
    case GRID_VARIANT_SMALL:
      return `column-gap: ${tokens.grid.gutterN}px;`
    case GRID_VARIANT_COLLAPSED:
      return 'column-gap: 0;'
    case GRID_VARIANT_DEFAULT:
      return `column-gap: ${2 * tokens.grid.gutterN}px;`
  }
}

const handlRow = ({ variantVertical }) => {
  switch (variantVertical) {
    case GRID_VARIANT_VERTICAL_DEFAULT:
      return `row-gap: 10px;`
    case GRID_VARIANT_VERTICAL_BIG:
      return 'row-gap: 20px;'
    default:
      return `row-gap: ${variantVertical};`
  }
}
// row-gap: 10px;
export const StyledGridContainer = styled.div`
  flex-grow: 1;
  display: grid;
  column-gap: ${2 * tokens.grid.gutterN}px;
  
  ${handlRow}

  ${handleVariant}

  ${({ cols }) =>
    cols
      ? `
        grid-template-columns: repeat(${cols}, minmax(0, 1fr));`
      : `
        grid-auto-columns: minmax(0, 1fr); 
        grid-auto-flow: column;
      `}
`

export const StyledGridCell = styled.div`
  ${({ span }) => (span ? `grid-column: span ${span};` : '')}
`
